import { Project } from '../../types/items';
import NameScriptTooltip from './tooltip/NameScriptTooltip';
import InstructionTypeGetter from './InstructionTypeGetter';

type Params = {
  project: Project | null;
};

class EditorJsTooltip {
  project: Project | null;

  constructor({ project }: Params) {
    this.project = project;
  }

  getTooltip(instructionElement: HTMLElement) {
    const instructionType = InstructionTypeGetter.get(instructionElement);
    if (instructionType) {
      return this.container[instructionType].getTooltip(instructionElement, { project: this.project });
    }
    return null;
  }

  get container() {
    return {
      nameScript: NameScriptTooltip,
    };
  }
}

export default EditorJsTooltip;
